svg4everybody();
import jQuery from 'jquery';
import angular from 'angular';
import 'angular-filter';
import 'angular-toastr';
import 'angular-toastr/dist/angular-toastr.tpls';
import 'angular-toastr/dist/angular-toastr.css';
import 'highcharts-ng';
import 'angular-inview/angular-inview';
import 'iso-currency/dist/isoCurrency.min';
import 'moment';
import 'zone.js';
import 'reflect-metadata';
import ngStorage from 'ngstorage';

import {downgradeComponent, downgradeInjectable} from '@angular/upgrade/static';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import Common from './common/common';
import Components from './components/components';
import Configs from './configs/configs';
import Directives from './directives/directives';
import Filters from './filters/filters';
import Resources from './resources/resources';
import Services from './services/services';
import Templates from './templates/templates';
import AppComponent from './app.component';

import { NumberWidgetComponentNg2 } from './components/explore/widgets/numberWidgetNg2.ts';
import { TagCloudWidgetComponentNg2 } from './components/explore/widgets/tagCloudWidgetNg2.ts';
import { ImagesRowExploreWidgetComponentNg2 } from './components/explore/widgets/imagesRowExploreWidgetNg2.ts';
import { ExploreSnapshotWidgetsComponentNg2 } from './components/explore/exploreSnapshotWidgetsNg2.ts';

export default angular.module('app', [
  'toastr',
  'angular.filter',
  'highcharts-ng',
  'angular-circles',
  'isoCurrency',
  'angular-inview',
  ngStorage.name,
  Common.name,
  Components.name,
  Configs.name,
  Directives.name,
  Filters.name,
  Resources.name,
  Services.name,
  Templates.name
])
  .directive('app', AppComponent)
  // TODO create angular 1 module where we add all the downgraded components
  .directive('exploreSnapshotWidgetsNg2Downgraded', downgradeComponent({component: ExploreSnapshotWidgetsComponentNg2}))


/** WEBPACK FOOTER **
 ** ./src/app.js
 **/